module.exports = __webpack_public_path__ + "media/site_templates/www.doorinstallation.company/images/our_services_2-c5865050cf023baab4d552cb5c20df53.jpg";